import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── QR PNG ─────────────────────────────────────────────────────────────

/** `GET /api/qr/{campaign_id}/png` — generate QR code as PNG Blob. */
export async function fetchCampaignQrPng(campaignId: string, axiosInstance?: AxiosInstance): Promise<Blob> {
  const client = axiosInstance || getVoiceFallbackClient();
  const url = `${apiConfig.voiceEndpoints.qr}/${campaignId}/png`;
  const response = await client.get<Blob>(url, { responseType: 'blob' });
  return response.data;
}
